import { render, staticRenderFns } from "./AltaDocente.vue?vue&type=template&id=7beee164&scoped=true&"
import script from "./AltaDocente.vue?vue&type=script&lang=js&"
export * from "./AltaDocente.vue?vue&type=script&lang=js&"
import style0 from "./AltaDocente.vue?vue&type=style&index=0&id=7beee164&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7beee164",
  null
  
)

export default component.exports